import React from 'react';
import { Container } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import CloseIcon from '@mui/icons-material/Close';
import './HuiToast.css';


interface HuiToastProps {
  toast: { message: string; type: 'success' | 'error' | 'warning' } | null;
  hideToast: boolean;
  onClose: () => void;
}

const HuiToast: React.FC<HuiToastProps> = ({ toast, hideToast, onClose }) => {
  if (!toast) return null;

  return (
    <Container maxWidth="lg" className="toast-container">
      <div className={`form-toast ${toast.type} ${hideToast ? 'hide' : ''}`}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {toast.type === 'success' ? (
            <FontAwesomeIcon icon={faCircleCheck} className="toast-icon" />
          ) : toast.type === 'error' ? (
            <FontAwesomeIcon icon={faCircleExclamation} className="toast-icon" />
          ) : (
            <FontAwesomeIcon icon={faCircleCheck} className="toast-icon" />
          )}
          <div>{toast.message}</div>
        </div>
        <CloseIcon className="close-toast-icon" onClick={onClose} />
      </div>
    </Container>
  );
};

export default HuiToast;